import { setupKeurtApiClient } from "~/instances/KeurtApiClient";
import { applyStoredCustomerTheme } from "~/utils/theme";

export default defineNuxtRouteMiddleware((to, from) => {
    const config = useRuntimeConfig();
    const url = config.public.apiBase;
    try {
        setupKeurtApiClient(url);
    } catch {
        console.log("Already setup client")
    }
    const token = useCookie("access_token");
    if (token.value) {
        applyStoredCustomerTheme();
    }
    return;
});
  
